import React from 'react';

import { Image } from 'semantic-ui-react';

import { register, registerClass } from 'sat-core';

import bronzeMedal from '../img/bronze.svg';
import goldMedal from '../img/gold.svg';
import silverMedal from '../img/silver.svg';

const t = register('LeaderboardService');

export default class LeaderboardService {
  static renderRankedLeaderboardFaculties = (rankedLeaderboardFaculties = [], {
    className = 'leaderboard-rank-list',
    shouldShowBadges = false
  } = {}) => {
    const hasRankedLeaderboardFaculties = Array.isArray(rankedLeaderboardFaculties) && rankedLeaderboardFaculties.length;

    if (!hasRankedLeaderboardFaculties) {
      rankedLeaderboardFaculties = [
        {
          id: 'placeholder',
          points: t('unknownPoints'),
          rank: t('unknownRank')
        }
      ];
    }

    return (
      <div className={className}>
        {rankedLeaderboardFaculties.map((facultyRankData, index) => {
          const { rank } = facultyRankData;
          let badgeSrc;
          if (shouldShowBadges && hasRankedLeaderboardFaculties) {
            if (index === 0) {
              badgeSrc = goldMedal;
            } else if (index === 1) {
              badgeSrc = silverMedal;
            } else {
              badgeSrc = bronzeMedal;
            }
          }
          return this.renderLeaderboardFaculty(facultyRankData, rank, badgeSrc);
        })}
      </div>
    );
  }

  static renderLeaderboardFaculty = (facultyRankData, rank, badgeSrc) => {
    const hasBadge = !!badgeSrc;

    // NOTE: Classroom Name (`facultyRankData.className`) is undefined for leaderboard reports generated prior to EMP-374.
    // Classroom Name is now the main label (instead of the School Name), so we need to always show something here.
    // Fall back to show School Name (`facultyRankData.name`) if we do not have `facultyRankData.className`.
    const classroomName = facultyRankData.className || facultyRankData.name;

    // NOTE: `facultyRankData.teacherName` is undefined for leaderboard reports generated prior to EMP-374.
    // If undefined, this sublabel will not be displayed in the UI.
    const teacherName = facultyRankData.teacherName || undefined;

    // NOTE: School Name will come back as `facultyRankData.name` for leaderboard reports generated prior to EMP-374.
    // For reports generated prior to EMP-374 (i.e. when Classroom Name is undefined), we consider the School Name to be the main label.
    // Since the UI School Name (institutionName) is now a sublabel, we will mark this as undefined for older reports.
    const institutionName = facultyRankData.className ? facultyRankData.schoolName : undefined;

    return (
      <div key={facultyRankData.id} className='leaderboard-rank-row-group-wrapper'>
        <div className='leaderboard-rank-row-classroom leaderboard-rank-row'>
          {!hasBadge && <div className='leaderboard-faculty-rank'>{rank}</div>}
          {hasBadge && <div className='leaderboard-faculty-badge'><Image src={badgeSrc} /></div>}
          <div className='leaderboard-faculty-name'>
            {classroomName}
          </div>
          <div className='leaderboard-faculty-score'>{facultyRankData.points || 0}</div>
        </div>
        <div className='leaderboard-rank-row-teacher leaderboard-rank-row'>
          {!hasBadge && <div className='leaderboard-faculty-rank' />}
          {hasBadge && <div className='leaderboard-faculty-badge' />}
          <div className='leaderboard-faculty-name'>
            {teacherName}
          </div>
          <div className='leaderboard-faculty-score' />
        </div>
        <div className='leaderboard-rank-row-institution leaderboard-rank-row'>
          {!hasBadge && <div className='leaderboard-faculty-rank' />}
          {hasBadge && <div className='leaderboard-faculty-badge' />}
          <div className='leaderboard-faculty-name'>
            {institutionName}
          </div>
          <div className='leaderboard-faculty-score' />
        </div>
      </div>
    );
  }
}

registerClass('LeaderboardService', LeaderboardService);
